<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="附件列表"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="item in fileList" :key="item.id">
        <template #title>
          <span class="custom-title">{{item.fileName}}</span>
        </template>
        <template #right-icon>
          <van-button
            type="info"
            size="mini"
            v-if="fileTypeList.includes(item.fileType)"
            @click="preview(item)"
            >预览</van-button
          >
          <van-button type="primary" size="mini" @click="download(item)"
            >下载</van-button
          >
        </template>
      </van-cell>
    </van-list>
    <van-image-preview v-model="showPreview" :images="previewImages" @closed="clearPreview">
      <template #cover>
        <div class="preview-save-tip">长按图片可保存到本地（仅在微信生效）</div>
      </template>
    </van-image-preview>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      ids: this.$route.query.attachmentIds,
      fileList: [],
      showPreview: false,
      previewImages: [],
      fileTypeList: ["jpeg", "png", "jpg", "webp", "gif", "bmp", "tiff"],
    };
  },
  beforeDestroy() {
    this.clearPreview();
  },
  methods: {
    download(file) {
      const token = localStorage.getItem("token");
      if (!token) {
        Toast.fail("登录已失效，请重新登录");
        return;
      }
      if (!file || !file.fileUrl) {
        Toast.fail("文件信息不完整，请刷新后重试");
        return;
      }
      // 与安装费 Excel 一致，使用真实地址，避免微信拦截 blob 临时链接。
      // 原生链接无法携带请求头，本下载接口支持通过 query 校验登录凭证。
      const link = document.createElement("a");
      link.style.display = "none";
      link.href =
        `/api/attachment/download?fileUrl=${encodeURIComponent(file.fileUrl)}` +
        `&fileName=${encodeURIComponent(file.fileName || "")}` +
        `&token=${encodeURIComponent(token)}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    preview(item) {
      this.axios({
        url: "/attachment/download",
        method: "get",
        params: {
          fileUrl: item.fileUrl,
        },
        responseType: "blob",
      }).then((res) => {
        const url = URL.createObjectURL(res.data);
        this.clearPreview();
        this.previewImages = [url];
        this.showPreview = true;
      });
    },
    clearPreview() {
      this.previewImages.forEach(url => URL.revokeObjectURL(url));
      this.previewImages = [];
    },
    goback() {
      this.$router.go(-1);
    },
    onLoad() {
      this.loading = true;
      this.getFileList();
    },
    // 获取文件列表
    getFileList() {
      this.axios({
        url: "/attachment/list",
        method: "post",
        data: {
          ids: this.ids,
        },
      }).then((res) => {
        this.fileList = res.data.data;
        this.loading = false;
        this.finished = true;
        console.log(this.fileList);
      });
    },
  },
};
</script>

<style scoped>
.preview-save-tip {
  position: fixed;
  bottom: 32px;
  bottom: calc(32px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  width: max-content;
  max-width: calc(100vw - 32px);
  padding: 10px 18px;
  border-radius: 20px;
  background: rgba(60, 60, 60, 0.9);
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  pointer-events: none;
}
.custom-title{
  display: inline-block;
  max-width: 310px;
  word-wrap: break-word;
}
</style>
